import { render, staticRenderFns } from "./ViewClaim.vue?vue&type=template&id=3856c790"
import script from "./ViewClaim.vue?vue&type=script&lang=js"
export * from "./ViewClaim.vue?vue&type=script&lang=js"
import style0 from "./ViewClaim.vue?vue&type=style&index=0&id=3856c790&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports